import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useLocationTimezone } from '@frontend/schedule-helpers';
import { theme } from '@frontend/theme';
import { Text, useTooltip } from '@frontend/design-system';

type Props = {
  title: string;
  locationId: string;
};

export const TableHeaderWithTimezoneInfo = ({ title, locationId }: Props) => {
  const { t } = useTranslation('schedule');
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'bottom-start' });
  const { locationTimezoneAbbr } = useLocationTimezone(locationId);

  return (
    <>
      <header css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
        <Text size='medium' css={{ color: theme.colors.neutral40 }}>
          {title}
        </Text>
        {locationTimezoneAbbr && (
          <span {...triggerProps}>
            <Icon name='info-small' size={16} />
          </span>
        )}
      </header>
      {locationTimezoneAbbr && (
        <Tooltip {...tooltipProps}>{`${t('Times shown are in')} ${locationTimezoneAbbr}`}</Tooltip>
      )}
    </>
  );
};
